import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  model,
  ModelSignal,
  output,
  OutputEmitterRef
} from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-clickable-row',
  imports: [NgClass],
  templateUrl: './clickable-row.component.html',
  styleUrl: './clickable-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClickableRowComponent {
  icon: InputSignal<string | undefined> = input<string | undefined>('');
  label: InputSignal<string | undefined> = input<string | undefined>('');
  placeholder: InputSignal<string | undefined> = input<string | undefined>('');
  disabled: InputSignal<boolean> = input<boolean>(false);
  loading: InputSignal<boolean> = input<boolean>(false);

  arrowLabel: InputSignal<string | undefined> = input<string | undefined>('');
  arrowLabelDisabled: InputSignal<boolean> = input<boolean>(false);

  // Works only when value provided
  isOpen: ModelSignal<boolean | null> = model<boolean | null>(null);

  buttonClick: OutputEmitterRef<Event> = output<Event>();
  arrowButtonClick: OutputEmitterRef<Event> = output<Event>();

  onButtonClick(event: Event): void {
    if (this.disabled() || this.loading()) {
      return;
    }

    if (this.isOpen() != null) {
      this.isOpen.update((isOpen: boolean | null): boolean => !isOpen);
    }

    this.buttonClick.emit(event);
  }

  onArrowButtonClick(event: Event): void {
    if (this.arrowLabelDisabled() || this.disabled() || this.loading()) {
      return;
    }

    event.stopPropagation();
    this.arrowButtonClick.emit(event);
  }
}
